<template>
  <div>
    <title-component :size="1" :lineSeparator="'under'">
      <translate>Welcome to Kiwa Certification</translate>
    </title-component>
    <div class="columns section-bordered">
      <!-- Right panel -->
      <div class="column is-6">
        <title-component :size="4">
          <translate>Log in to the portal</translate>
          <template slot="subtitle">
            <translate>Log in with the e-mail address you registered with the application.</translate>
          </template>
        </title-component>
        <!-- Login form -->
        <div class="link-dashboard" v-if="authUser.isLoggedIn()">
          <router-link to="dashboard" v-translate>Go to dashboard</router-link>
        </div>
        <template v-if="formDescriptors && formDatas">
          <form-component
            v-for="formDescriptor in formDescriptors"
            :formDescriptor="formDescriptor"
            :formData="getFormDataForDescriptor(formDescriptor)"
            :key="formDescriptor.id"
            class="login-form">
          </form-component>
        </template>
        <!-- Non field error handling -->
        <transition
          name="fade"
          appear
          appear-active-class="animated fadeIn"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="{ enter: 200, leave: 200 }">
          <div v-if="mixin.error" class="notification is-danger">
            {{ mixin.error }}
          </div>
        </transition>

        <div class="row-spacer"></div>

        <div class="columns is-mobile btns-container">
          <div class="column">
            <submit-btn-component
              ref="enterButton"
              class="is-primary submit-button is-large is-uppercase center-vertically"
              @submit="submitLoginUser"
              v-translate>
              Login
            </submit-btn-component>
          </div>
          <div class="column has-text-right">
            <router-link to="reset-password" v-translate>
              Forgot your password?
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Browser compatiblity check -->
    <browser-compatibility-component />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import FormComponent from '@/components/form/FormComponent'
  import TitleComponent from '@/components/layout/TitleComponent.vue'
  import { formHandlerMixin, onKeyEnterMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'
  import AuthUser from '@/classes/auth/AuthUser'
  import BrowserCompatibilityComponent from '@/components/layout/BrowserCompatibilityComponent'

  export default {
    name: 'login-view',
    mixins: [onKeyEnterMixin, formHandlerMixin, setContainedHeightMixin],
    data () {
      return {
        authUser: AuthUser,
        submitRequest: null
      }
    },
    components: {
      TitleComponent,
      SubmitBtnComponent,
      FormComponent,
      BrowserCompatibilityComponent
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.authModule.formDescriptors,
        formDatas: state => state.authModule.formDatas
      })
    },
    methods: {
      ...mapActions([
        'loginUser',
        'setupLoginForm',
        'clearData'
      ]),
      submitLoginUser (btn) {
        let requestData = {
          formDatas: this.formDatas
        }
        this.submitRequest = this.loginUser
        this.submitForm(requestData, btn)
      }
    },
    created () {
      this.setupLoginForm().catch((err) => {
        this.handleError(err)
      })
    },
    beforeDestroy () {
      this.clearData()
    }
  }
</script>

<style lang="sass" scoped>
  .link-dashboard
    text-align: center
    margin: 1.5rem 0

  .login-form
    margin-top: 0

  .row-spacer
    margin-bottom: 3.5rem
</style>
